// components/Footer.js
import { Link } from "@/lib/i18n";
import React from 'react'; // 确保导入 React
import Image from "next/image";
import IconImage from "../../public/favicon.svg";
import {useTranslations} from 'next-intl';
import { SmartText } from '@/components/ui/SmartFont';

export function Footer() {
  const t = useTranslations('footer');
  const size = 30;
  return (
    <footer className="bg-background text-muted-foreground border-t">
      <div className="flex flex-col justify-center items-center max-w-7xl text-center mx-auto py-12 px-4 sm:px-6 lg:px-8 lg:text-start">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-16">
          <div className='flex flex-col justify-center items-center lg:items-start lg:justify-start'>
            <h3 className="text-sm font-bold tracking-normal">
              <Link href="/" className="flex items-center space-x-2">
                <Image
                  src={IconImage}
                  className="block opacity-80"
                  width={size}
                  height={size}
                  alt="DomainScore"
                />
                <span className="inline-block font-bold">
                  <SmartText>Tarot Card Generator</SmartText>
                </span>
              </Link>
            </h3>
            <p className="mt-4 text-xs">
              <SmartText>{t('description')}</SmartText>
            </p>
            {/* <div className='mt-4 text-xs'>
              <SmartText>
                {t('builtWith')}
                <Link href="https://gitbase.app/" target='_black' className="ml-1 text-xs underline">
                  GitBase
                </Link>
              </SmartText>
            </div> */}
          </div>
          <div className=''>
            <h3 className="text-sm font-semibold tracking-wider uppercase">
              <SmartText>{t('quickLinks')}</SmartText>
            </h3>
            <ul className="mt-4 space-y-4">
              <li>
                <Link href="/" className="text-base hover:text-primary hover:underline">
                  <SmartText>{t('home')}</SmartText>
                </Link>
              </li>
              <li>
                <Link href="/blog" className="text-base hover:text-primary hover:underline">
                  <SmartText>{t('blog')}</SmartText>
                </Link>
              </li>
              <li>
                <Link href="/ai-tarot-reading" className="text-base hover:text-primary hover:underline">
                  <SmartText>{t('aiTarotReading')}</SmartText>
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <h3 className="text-sm font-semibold tracking-wider uppercase">
              <SmartText>{t('legal')}</SmartText>
            </h3>
            <ul className="mt-4 space-y-4">
            <li>
                <Link href="/" className="text-base">
                  <SmartText>{t('privacy')}</SmartText>
                </Link>
              </li>
              <li>
                <Link href="/" className="text-base">
                  <SmartText>{t('termsOfService')}</SmartText>
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <h3 className="text-sm font-semibold tracking-wider uppercase">
              <SmartText>{t('connect')}</SmartText>
            </h3>
            <ul className="mt-4 space-y-4">
              <li>
                <Link href={"mailto:yuweiloopy@gmail.com"} className="text-base">
                  <SmartText>{t('support')}</SmartText>
                </Link>
              </li>
            </ul>
          </div>
        </div>
        <div className="mt-8 border-t pt-8">
          <p className="text-base text-center">
            <SmartText>&copy; {new Date().getFullYear()} TarotCardGenerator. {t('copyright')}</SmartText>
          </p>
        </div>
      </div>
    </footer>
  );
}